// extracted by mini-css-extract-plugin
export default {"banner":"ContactRoute_banner__XpEL6","banner-video":"ContactRoute_banner-video__2TK4k"};